export const danhMucThuKhac = {
  sections: {
    list: { title: 'Other fee catalog' },
    detail: { title: 'Other fee catalog' },
  },
  titles: { add: 'Add fee item', edit: 'Edit fee item' },
  columns: {
    code: 'Code',
    summary: 'Fee name',
    note: 'Description',
    loaiThuKhac: 'Fee type',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    status: 'Status',
    onOffAction: 'On/Off',
  },
  filter: {
    searchPlaceholder: 'Search by fee code, name...',
    textDetailTitle: 'Detailed filter',
  },
  filters: {
    hintSection: 'Hint',
    hintBody: 'Manage additional fee items used on invoices and return slips.',
    statusAll: 'All',
    loaiThuKhacAll: 'All',
  },
  loaiThuKhac: {
    CO_DINH: 'Fixed (VND)',
    PHAN_TRAM: 'Percentage (%)',
    TUY_CHON: 'Optional',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Paused',
  },
  trangThai: {
    DANG_HOAT_DONG: 'Active',
    TAM_NGUNG: 'Paused',
  },
  actions: {
    pause: 'Pause',
    activate: 'Activate',
  },
  messages: {
    loadError: 'Failed to load fee catalog.',
    deleteSuccess: 'Fee item deleted.',
    noData: 'No fee items.',
    listSummary: '{count} item(s) total',
    saveSuccess: 'Fee item saved.',
    statusChanged: 'Status updated.',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected fee items?',
    bulkDeleteSuccess: 'Deleted {count} fee items',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} item(s) failed.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No fee items selected to delete',
  },
  form: {
    maThuKhac: 'Fee code',
    maThuKhacPlaceholder: 'Leave blank to auto-generate (TK0001…)',
    maThuKhacHint: 'If empty, the system generates TK + 4 digits.',
    tenThuKhac: 'Fee name',
    loaiThuKhac: 'Fee type',
    giaTri: 'Amount (VND)',
    phanTram: 'Percentage (%)',
    moTa: 'Description',
  },
  validation: {
    tenRequired: 'Please enter a fee name.',
    giaTriRequired: 'Fixed amount must be a non-negative number.',
    phanTramRequired: 'Percentage must be between 0 and 100.',
  },
  placeholders: {
    formTitle: 'Other fee catalog',
    formBody: '',
  },
  reorder: {
    open: 'Reorder',
    title: 'Reorder other fees',
    hint: 'Use the up and down buttons. This order is the column order of other fees on the invoice list.',
    move: 'Move',
    moveUp: 'Up',
    moveDown: 'Down',
    saved: 'Other fee order updated',
    saveFailed: 'Could not update the order',
  },
}
